import { Config } from '@/config';
import apiService from '@/services/api.service';
import { ParticipationState } from '@/store/consultation.interface';

class ConsultationResponseService {
  async getParticipationState(consultationId: number): Promise<ParticipationState> {
    const response = await apiService.get(`${Config.api.backend.urlV2}/consultations/${consultationId}/response`);
    return response.data as ParticipationState;
  }

  async submitResponse(consultationResponseId: number): Promise<void> {
    await apiService.post(`${Config.api.backend.urlV2}/consultation-responses/${consultationResponseId}/:complete`);
  }
}

export const consultationResponseService = new ConsultationResponseService();
